/**
 * Escape HTML menjadi teks mentah (tidak dirender sebagai tag HTML).
 * @param input string
 * @returns string
 */
export function escapeHTML(input: string): string {
  const div = document.createElement('div')
  div.textContent = input
  return div.innerHTML
}

export interface SanitizeOptions {
  allowedTags?: string[]
  allowedAttrs?: string[]
}

/**
 * Sanitize HTML: hanya izinkan tag & atribut tertentu.
 * Tag berbahaya (script, style, iframe, dll) dibuang total.
 * @param input string
 * @param options SanitizeOptions
 * @returns string
 */
export function sanitizeHTML(input: string, options: SanitizeOptions = {}): string {
  const allowedTags = options.allowedTags || ['b', 'i', 'em', 'strong', 'p']
  const allowedAttrs = options.allowedAttrs || []

  const parser = new DOMParser()
  const doc = parser.parseFromString(input, 'text/html')

  // 🚨 Hapus langsung tag berbahaya + isinya
  doc.body.querySelectorAll('script, style, iframe, object, embed, link, meta').forEach(el => {
    el.remove()
  })

  // 🔍 Iterasi semua elemen lain
  doc.body.querySelectorAll('*').forEach((el: Element) => {
    const tagName = el.tagName.toLowerCase()

    // Jika tag tidak ada di whitelist → unwrap (hapus tag tapi simpan isinya)
    if (!allowedTags.includes(tagName)) {
      el.replaceWith(...Array.from(el.childNodes))
      return
    }

    // Cek & bersihkan atribut
    Array.from(el.attributes).forEach(attr => {
      const attrName = attr.name.toLowerCase()
      const attrValue = attr.value

      const isEventHandler = /^on/i.test(attrName) // onclick, onmouseover, dll
      const isJsScheme = attrValue?.toLowerCase().startsWith('javascript:')

      if (isEventHandler || isJsScheme || !allowedAttrs.includes(attrName)) {
        el.removeAttribute(attrName)
      }
    })
  })

  return doc.body.innerHTML
}
